import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

function Thankyou() {
    const [query] = useSearchParams()
    const [queryObj, setQueryObj] = useState()
    useEffect(() => {
        setQueryObj(Object.fromEntries(query.entries()))

    }, [query])

    return (
        <main className='bg-[#161623] text-center'>
            <div className='h-full min-h-[calc(100vh-60px)] text-gray-300 container mx-auto py-8 px-2'>
                <h1 className='text-4xl font-bold'>
                    Thank you {queryObj?.name}, for purchasing BlogCode
                </h1>
                <p className='text-xl mt-4'>A Github invite for the repository has been sent already!</p>

            </div>
        </main>
    )
}

export default Thankyou